import TemplateView from "../../TemplateView";
import Button from "../../components/Button";

export default class DialogFooter extends TemplateView{
    constructor({
        submitBtnLabel,
        cancelBtnLabel,
        onSubmitCb = () => {},
        onCancelCb = () => {}
    }){
        super(null)

        this.params = {
            submitBtnLabel,
            cancelBtnLabel
        }

        this.callbacks = {
            onSubmitCb,
            onCancelCb
        }
    }

    templateHtml(){
        return '<div class="dialogFooter">'
    }

    afterRender(){
        new Button({
            additionalClass: 'applyBtn',
            label: this.params.submitBtnLabel,
            onClickCb: this.callbacks.onSubmitCb
        }).init(this.getEl())

        new Button({
            additionalClass: 'cancelBtn',
            label: this.params.cancelBtnLabel,
            onClickCb: this.callbacks.onCancelCb
        }).init(this.getEl())
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/DialogFooter.js